export { default as translations } from './translations.json';

export const REMINDER_WINDOWS = {
  h24: { label: '24 hours', hoursUntil: 24, minHours: 2 },
  h1: { label: '1 hour', hoursUntil: 2, minHours: 0 },
};

/**
 * Calculate hours until a booking starts.
 * @param {string} startDate — ISO date string
 * @returns {number} — hours until start (may be negative if in the past)
 */
export const hoursUntilBooking = (startDate) =>
  (new Date(startDate).getTime() - Date.now()) / 3600000;

/**
 * Check if a reminder should be sent.
 * @param {Object} reminders — current reminders from metadata
 * @param {string} type — 'h24' | 'h1'
 * @param {number} hoursUntil — hours until booking
 * @returns {boolean}
 */
export const shouldSendReminder = (reminders, type, hoursUntil) => {
  const window = REMINDER_WINDOWS[type];
  if (!window) return false;
  if (reminders?.[type]?.sentAt) return false;
  return hoursUntil <= window.hoursUntil && hoursUntil > window.minHours;
};
